/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `alpha` - ALPHA
 * * `standard` - STANDARD
 */
export enum ReleaseChannel {
  ALPHA = 'alpha',
  STANDARD = 'standard',
}
